import palette from '../palette';

export default {
	defaultProps: {
		color: palette.primary.main,
	}
};